import { Global } from '@emotion/react';
import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import Head from 'next/head';
import React from 'react';

import { PatientGoogleReCaptcha } from '~/components/partials/PatientGoogleReCaptcha';
import { theme } from '~/styles/theme';

import { styles } from './styles';

type Props = {
  children?: React.ReactNode;
};

const Root = styled('div')(({ theme }) =>
  css({
    width: '100%',
    margin: 0,
    backgroundColor: theme.colors.background.patientBg,
  }),
);

const Main = styled('div')(() =>
  css({
    width: '100%',
    margin: '0 auto',
  }),
);

export const Checkin = (props: Props) => {
  return (
    <>
      <Global styles={styles(theme)} />
      <Head>
        <meta name="robots" content="noindex,nofollow" />
        <title>調剤薬局チェックインサービス</title>
      </Head>
      <Root>
        <Main>{props.children}</Main>
        <PatientGoogleReCaptcha />
      </Root>
    </>
  );
};
